<template>
    <div class="grid inline corner bg-default gap-3 xs-grid-cols-1 center outline m-t-4" v-if="!isNHS && !isRDC && !isRentals">
        <div v-if="ctaInfoIconClass" >
            <i class="circle default disabled" :class="ctaInfoIconClass"></i>
        </div>
        <div class="f4 text-bold lh-normal">{{ctaInfoTitleText}}</div>
        <div class="f6 text-center"> {{ctaInfoSubtitleText}}</div>
        <a class="btn primary regular w-85" @click="onCTAClick({cta: ctaInfoCtaText, section: ctaInfoSectionText})" role="button">{{ctaInfoCtaText}}</a>
    </div>
</template>

<script>
export default {
    name: 'DppCtaCardPresentational',
    props: {
        isNHS: Boolean,
        isRDC: Boolean,
        isRentals: Boolean,
        ctaInfoIconClass: String,
        ctaInfoTitleText: String,
        ctaInfoSubtitleText: String,
        ctaInfoCtaText: String,
        ctaInfoSectionText: String,
        onCTAClick: Function,
    },
};
</script>

<style lang="scss">
@use './dpp-ctacard.scss' as *;
</style>
